export default __webpack_public_path__ + "static/media/stock price.b0f13cc3.png";